




































































































































































import {Vue, Component} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';
import {addClass, removeClass} from '@/utils/classUtils';

@Component
export default class ProductBulkImageUpload extends Vue {

  mounted () {
    addClass(document.body, 'popup popup_large');

    if (window.opener) {
      const contentWidth = $('#container').width() + 30;
      const contentHeight = $('.content').height() + 106;
      window.resizeTo(contentWidth, contentHeight);
    }
  }

  beforeDestroy () {
    removeClass(document.body, 'popup popup_large');
  }

  private toI18n(needToI18nStr: string, bCommon: boolean = false): string {
    return toI18n(this.$t((bCommon ? '' : 'PRODUCT_BULK_IMAGE_') + needToI18nStr));
  }
}
